import { createSelector } from '@reduxjs/toolkit';

import { ReduxState } from '../state';
import { ApplicationState, TosUpdatedDatesStatus } from './types';

export const selectApplication = (state: ReduxState): ApplicationState =>
  state.Application;

export const selectApplicationTosUpdateDates = createSelector(
  selectApplication,
  (application) => application.tosUpdatedDates.dates
);

export const selectHasApplicationTosUpdateDatesLoaded = createSelector(
  selectApplication,
  (application) =>
    application.tosUpdatedDates.status === TosUpdatedDatesStatus.Loaded
);

export const selectApplicationTosNextUpdateDates = createSelector(
  selectApplication,
  (application) => application.tosNextUpdateDates.dates
);

export const selectApplicationTosNextUpdateStatus = createSelector(
  selectApplication,
  (application) => application.tosNextUpdateDates.status
);

export const selectApplicationIpAddress = createSelector(
  selectApplication,
  (application) => application.ipAddress
);
